import isNumber from 'lodash/isNumber';

import makeRequest from 'api/makeRequest';
import environment from 'environment';
import { handleError } from 'services/ErrorService/ErrorService';
import makeCloudFunctionRequest from './makeCloudFunctionRequest';

export const CHAT_TIMER_CONFIG_URL = `${environment.app.serverApiUrl}/cloud-functions/v2/conversation-timer-config/expertTimeoutV2`;

export const fetchChatTimerConfig = async () => {
  const { timerPeriodSeconds } = await makeRequest(CHAT_TIMER_CONFIG_URL);

  return isNumber(timerPeriodSeconds) ? timerPeriodSeconds * 1000 : 0;
};

export const getToolData = async (simplrAccountId, toolArray) => {
  const params = {
    simplrAccountId,
    toolArray,
  };

  try {
    return await makeCloudFunctionRequest('getToolData', params);
  } catch (error) {
    handleError({ error });
  }
};

export const getStandardToolDomains = (simplrAccountId) => {
  const params = {
    simplrAccountId: simplrAccountId,
  };

  return makeCloudFunctionRequest('getToolDomains', params).then((response) => {
    return response;
  });
};

export const getGlobalParseConfigsList = async (list) => {
  return makeCloudFunctionRequest('getGlobalConfigsList', { list });
};
